import { acceptHMRUpdate, defineStore } from 'pinia';
import { getApiV2MarketingBanners, MarketingBannersDataItem } from '@/api/pensa';
import { ObjectToCamel } from '@pasta-evangelists/pasta-types';

type MarketingBanner = ObjectToCamel<MarketingBannersDataItem>;
type MarketingBanners = MarketingBanner[];

interface StoreState {
  banners: MarketingBanners;
}

const filterActiveBannersByCategory = (
  banners: MarketingBanners,
  category: string
): MarketingBanners => {
  if (!banners.length) return [];
  return banners
    .filter(banner => category === banner.attributes.category && banner.attributes.active)
    .sort((a, b) => (a.attributes.position || 0) - (b.attributes.position || 0));
};

const marketingBannersStore = defineStore('marketingBannersStore', {
  state: (): StoreState => ({
    banners: [],
  }),
  getters: {
    getActiveProductBoxBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'rk-menu');
    },
    getActiveMyAccountBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'my-account');
    },
    getActiveCheckoutBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'rk-checkout');
    },
    getActivePastaNowMenuBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'pasta-now-menu');
    },
    getActivePastaNowCheckoutBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'pasta-now-checkout');
    },
    getActiveAddressLookupBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'address-lookup');
    },
    getActiveEventsMenuBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'events-menu');
    },
    getActiveEventsCheckoutBanners(): MarketingBanners {
      return filterActiveBannersByCategory(this.banners, 'events-checkout');
    },
  },
  actions: {
    async getMarketingBanners() {
      const result = await getApiV2MarketingBanners();

      this.$patch(state => (state.banners = result.data));
    },
  },
});

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(marketingBannersStore, import.meta.hot));

export default marketingBannersStore;
